// extracted by mini-css-extract-plugin
export var circle = "_h-2";
export var icon = "_h-a";
export var iconHighlight = "_h-0";
export var lg = "_h-8";
export var md = "_h-7";
export var outline = "_h-4";
export var sm = "_h-6";
export var square = "_h-1";
export var xl = "_h-9";
export var xs = "_h-5";
export var xxs = "_h-3";